// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/home.scss'

// Real Estate Programs Search Form
async function getREPSForm ($f) {
  $f.load()
  import(
    /* webpackChunkName: "realEstateProgramsSearchForm", webpackPrefetch: true */ './js/components/realEstateProgramsSearchForm.js'
  ).then(() => {
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion du formulaire de recherche rapide des programmes
  const $e = $('.rep-search-form.in')
  if ($e.length) {
    $e.waypoint(
      function () {
        getREPSForm($e)
        this.destroy()
      },
      {
        offset: '100%'
      }
    )
  }
})
